import React from 'react';

import { TableCell, TableRow } from '@material-ui/core';

import { useAssignResultsState } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { getGBNRowResult } from '../Utils/getGBNRowResult';

interface IProps {
  hole: string;
  index: number;
  onClick: (index: number) => () => void;
}

export const SimpleGNBTableRow = (props: IProps) => {
  const { hole, index, onClick } = props;

  const { selectedScoreType, gbnResults, selectedRoundFormat } = useAssignResultsState();

  const holeResults = gbnResults[Number(hole)];

  return (
    <TableRow
      id={`clickableRowResult-${index}`}
      key={`tableRowResult-${index}`}
      onClick={onClick(index)}
    >
      <TableCell className="index">{Number(hole) + 1}</TableCell>
      <TableCell className="playerName">
        {`${holeResults[0].userFirstName[0]}. ${holeResults[0].userLastName}`}
      </TableCell>
      <TableCell className="result">
        {getGBNRowResult(gbnResults, hole, selectedScoreType, selectedRoundFormat)}
      </TableCell>
      <TableCell className="ribbon-metaContainer">
        <div className="ribbon-container">
          <span className="ribbon">SKIN</span>
        </div>
      </TableCell>
    </TableRow>
  );
};
